import React from "react";

const TYPES = [
  {
    key: "DEFAULT",
    label: "Esercizio",
    description: "Esercizio singolo standard",
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" />
      </svg>
    ),
  },
  {
    key: "SUPERSET",
    label: "Superset",
    description: "Combinazione di 2-5 esercizi",
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M6.429 9.75L2.25 12l4.179 2.25m0-4.5l5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L12 12.75 6.429 9.75m11.142 0l4.179 2.25-9.75 5.25-9.75-5.25 4.179-2.25" />
      </svg>
    ),
  },
  {
    key: "STRIPPING",
    label: "Stripping",
    description: "Serie a scalare con riduzione carico",
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 4.5h14.25M3 9h9.75M3 13.5h5.25m5.25-.75L17.25 9m0 0L21 12.75M17.25 9v12" />
      </svg>
    ),
  },
  {
    key: "CHECK",
    label: "Check",
    description: "Questionario di valutazione",
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15a2.25 2.25 0 012.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
      </svg>
    ),
  },
];

type Props = {
  selectedType: string;
  onSelectType: (type: string) => void;
};

export const StepExerciseType: React.FC<Props> = ({
  selectedType,
  onSelectType,
}) => {
  return (
    <div className="flex flex-col items-center justify-center h-full py-8">
      <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
        Che tipo di esercizio vuoi aggiungere?
      </h2>
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-8">
        Seleziona la tipologia per continuare
      </p>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 w-full max-w-3xl">
        {TYPES.map((t) => {
          const active = selectedType === t.key;
          return (
            <button
              key={t.key}
              onClick={() => onSelectType(t.key)}
              className={`flex flex-col items-center gap-3 p-6 rounded-xl border-2 transition-all ${
                active
                  ? "border-blue-500 bg-blue-50 dark:bg-blue-900/30 shadow-md"
                  : "border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 hover:border-gray-300 dark:hover:border-gray-500 hover:shadow-sm"
              }`}
            >
              <div
                className={`${
                  active
                    ? "text-blue-600 dark:text-blue-400"
                    : "text-gray-400 dark:text-gray-500"
                }`}
              >
                {t.icon}
              </div>
              <div className="text-center">
                <p
                  className={`text-sm font-semibold ${
                    active
                      ? "text-blue-700 dark:text-blue-300"
                      : "text-gray-700 dark:text-gray-300"
                  }`}
                >
                  {t.label}
                </p>
                <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">
                  {t.description}
                </p>
              </div>
              {active && (
                <div className="w-5 h-5 rounded-full bg-blue-500 flex items-center justify-center">
                  <svg
                    className="w-3 h-3 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={3}
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};
